import '../assets/font/Inter-Bold-normal';
import '../assets/font/Inter-Light-normal';
import '../assets/font/Inter-Regular-normal';
import '../assets/font/Inter-Medium-normal';
import '../assets/font/Inter-SemiBold-normal';

export default {
  methods: {
    async addHeaderPDF(doc) {
      let text = '';

      doc.setFont('Inter-Regular');
      doc.setFontSize(6);
      text = 'Sítio do Periquito - Rodovia Perdões, Km 03, AMG';
      doc.text(100, 10, text);
      text = '1650, Zona Rural, Ribeirão Vermelho - MG';
      doc.text(100, 14, text);

      doc.setFont('Inter-SemiBold');
      text = 'Tel:';
      doc.text(100, 18, text);
      doc.setFont('Inter-Regular');
      text = '(35) 99250-5255';
      doc.text(104, 18, text);

      doc.setFont('Inter-SemiBold');
      text = 'E-mail:';
      doc.text(100, 22, text);
      doc.setFont('Inter-Regular');
      text = 'comercial@cogumelosumami.com.br';
      doc.text(107.5, 22, text);

      doc.setFont('Inter-SemiBold');
      text = 'Site:';
      doc.text(100, 26, text);
      doc.setFont('Inter-Regular');
      text = 'www.cogumelosumami.com.br';
      doc.text(105, 26, text);

      doc.setFont('Inter-SemiBold');
      text = 'Redes sociais:';
      doc.text(100, 30, text);
      doc.setFont('Inter-Regular');
      text = '@cogumelosumami';
      doc.text(115, 30, text);

      return doc;
    },
    addTitlePDF(doc, title, subtitle) {
      // Define o texto que você deseja centralizar
      let text = title;

      // Define a cor do texto
      doc.setTextColor('#2C2C2C');

      // Define a fonte e o tamanho do texto
      doc.setFontSize(56);
      doc.setFont('Inter-Bold');

      // Obtém a largura do texto
      let textWidth = doc.getTextWidth(text);

      // Obtém a largura da página
      let pageWidth = doc.internal.pageSize.getWidth();

      // Calcula a posição x do texto
      let textX = (pageWidth - textWidth) / 2;

      // Adiciona o texto centralizado à página
      doc.text(textX, 60, text);

      text = subtitle;
      doc.setFontSize(24);
      doc.setFont('Inter-Regular');

      textWidth = doc.getTextWidth(text);
      pageWidth = doc.internal.pageSize.getWidth();
      textX = (pageWidth - textWidth) / 2;

      doc.text(textX, 70, text);

      return doc;
    },
  },
};
